import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http.getData(`/register/${registerId}/rmk`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function prefill(registerId: string | number) {
  const response = await http.getData(`/register/${registerId}/rmk/prefill`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/rmk/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data: any) {
  const response = await http.postData("/rmk", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: any) {
  const response = await http.putData(`/rmk/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDpjp(id: number, data: { password: string }) {
  const response = await http.putData(`/rmk/${id}/sign-dpjp`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

/** TTD untuk tab "Sebab Kematian" — tanpa pra-validasi blanko Ringkasan Masuk & Keluar. */
async function signSebabKematian(id: number, data: { password: string }) {
  const response = await http.putData(`/rmk/${id}/sign-sebab-kematian`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/rmk/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

function print(id: number) {
  window.open(`${http.getAPI()}/rmk/${id}/pdf`, "_blank");
}

/** Cetak hanya lembar Sebab Kematian (tanpa syarat keadaan keluar pasien). */
function printSebabKematian(id: number) {
  window.open(`${http.getAPI()}/rmk/${id}/pdf-sebab-kematian`, "_blank");
}

export default {
  getByRegister,
  prefill,
  find,
  create,
  update,
  signDpjp,
  signSebabKematian,
  destroy,
  print,
  printSebabKematian
};
